StringToSymbolRegistry